// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCBfBEnxboXtziYUQ3UCWNMvPjGx-a3G7U",
  authDomain: "rb-basecamp.firebaseapp.com",
  databaseURL: "https://rb-basecamp.firebaseio.com",
  projectId: "rb-basecamp",
  storageBucket: "rb-basecamp.firebasestorage.app",
  messagingSenderId: "461928651461",
  appId: "1:461928651461:web:95ffc594f579ef93a9eeac",
  measurementId: "G-EYT258P5QM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const requestPermission = async () => {
  try {
    await Notification.requestPermission();
    console.log('Notification permission granted.');

    // Get the token
    const currentToken = await getToken(messaging, { vapidKey: 'BFvQpCTjiaDH7oEhVULbpSkjuOJ78dimURwMmLE70tRM57CLxssSwx8Bb-zwrmlRod1un48NGQuvIyZ3H_OXE2Q' });
    if (currentToken) {
      localStorage.setItem('fId', currentToken);
      console.log('FCM Token:', currentToken);
      // Save the token to your server or use it to subscribe to notifications
    } else {
      console.error('No registration token available. Request permission to generate one.');
    }
  } catch (error) {
    console.error('Unable to get permission to notify.', error);
  }
};

export { messaging, requestPermission };
